enum JOB_TYPES {
  PHASE_ONE = 'Phase 1',
  ENVIRO_FORMS = 'Enviro Forms',
  HAZARD_MAP = 'Hazard Map'
}

export default JOB_TYPES;
